export interface LicenseSummaryProps {
  actions: string[];
  deliveryMode?: string;
  limitations?: string[];
}

export function LicenseSummary({ actions, deliveryMode = 'Controlled use', limitations = [] }: LicenseSummaryProps) {
  return (
    <div style={{ fontSize: '0.875rem', lineHeight: 1.5 }}>
      <p style={{ margin: '0 0 0.5rem', fontWeight: 600 }}>License summary</p>
      <ul style={{ margin: 0, paddingLeft: '1.1rem', color: 'var(--3ds-text-secondary)' }}>
        <li>Delivery: {deliveryMode}</li>
        {actions.map((action) => (
          <li key={action}>Permitted: {action}</li>
        ))}
        {limitations.map((lim) => (
          <li key={lim}>Limitation: {lim}</li>
        ))}
      </ul>
    </div>
  );
}
